import Button from "@components/Button/Button";
import SubscribeTrigger from "@components/Header/SubscribeTrigger/SubscribeTrigger";
import { KeywordLimitModalProps } from "@components/KeywordFilter/utlis/types";
import Modal from "@components/Modal/Modal";

/**
 * A modal component that informs the user they have reached their keyword limit
 * and provides an option to subscribe for an increased limit or dismiss the modal.
 *
 * @component
 * @param {KeywordLimitModalProps} props - The props for the modal component.
 * @param {() => void} props.onClose - Callback function to close the modal.
 * @param {boolean} props.isModalOpen - Boolean indicating whether the modal is open.
 *
 * @returns {React.ReactElement} The rendered modal component.
 */
export default function KeywordLimitModalVersion2({
  onClose,
  isModalOpen,
}: KeywordLimitModalProps): React.ReactElement {
  return (
    <Modal
      isModalOpen={isModalOpen}
      setIsModalOpen={onClose}
      dialogPanelClassNames="absolute h-max md:left-1/2 md:top-1/2 md:-translate-x-1/2 md:-translate-y-1/2 md:w-[450px] w-full bg-white rounded-t-[8px] md:rounded-[8px] bottom-0"
    >
      <div
        className="px-8 py-4"
        data-testid="keyword-limit-modal-version-2-component"
      >
        <p className="text-left font-public-sans text-gray-850">
          You have reached your limit of 3 keywords. Become a subscriber to
          follow up to 30 keywords.
        </p>

        <SubscribeTrigger rootClassName="w-full h-[60px] mb-4 text-white" />

        <Button onClick={onClose} className="mx-auto border-none">
          <p>Maybe later</p>
        </Button>
      </div>
    </Modal>
  );
}
